import React from "react";
import ResponsiveLayout from "../../common_components/ResponsiveLayout";
import PrintProjectsDesktop from "./desktop/PrintProjectsDesktop";
import PrintProjectsMobile from "./mobile/PrintProjectsMobile";

const PrintProjects = () => {
  return (
    <ResponsiveLayout
      MobileComponent={PrintProjectsMobile}
      DesktopComponent={PrintProjectsDesktop}
    />
  );
};

export default PrintProjects;